<template>
    <component :is="$auth.isSubdomainActive() ? 'div' : 'common-page-plain'">
        <common-content-spacer class="timeline-page" height="medium" :isCenter="true">
            <common-button
                type="primary"
                size="medium"
                :label="$t('common.microcopy.download_pdf')"
                @click="downloadPdf()"
            ></common-button>
            <timeline-filter
                :class="filterClass"
                :filter="filterApplied"
                :locations="locations"
                @filter-change="filterChanged"
            ></timeline-filter>
            <common-user-selector
                v-if="availabilityPerformers.length > 1"
                :users="availabilityPerformers"
                :selectedUserId="selectedPerformerId"
                @emitEvent="userSelected($event)"
            ></common-user-selector>
        </common-content-spacer>
        <common-content-spacer class="timeline-page" height="tiny">
            <timeline class="timeline-page__timeline" :reservations="reservations"></timeline>
        </common-content-spacer>
    </component>
</template>

<script>
    import Timeline from 'components/page-elements/reservations/Timeline'
    import CalendarEventAPI from 'api/CalendarEventAPI'
    import Store from '~/store'
    import ReservationSortFilterEnum from 'enums/reservation_sort_filter.enum'
    import ReservationStatusFilterEnum from 'enums/reservation_status_filter.enum'
    import dayjs from 'dayjs'
    import TimelineFilter from 'components/page-elements/reservations/TimelineFilter'
    import RoutesEnum from 'enums/routes.enum'
    import AvailabilityAPI from 'api/AvailabilityAPI'
    import UsersAPI from 'api/UsersAPI'

    export default {
        components: { Timeline, TimelineFilter },

        data: () => ({
            filterApplied: {},
            reservations: {},
            selectedPerformerId: undefined,
            availabilityPerformers: [],
            locationPerfromers: [],
            isFirstLoad: true,
            isAviabilityPerfByLocCalled: false,
            oldLocationId: undefined,
            locations: {},
        }),

        computed: {
            currentUser() {
                return this.$auth.getUser()
            },

            statusOptions() {
                return Object.values(ReservationStatusFilterEnum)
                    .filter(
                        (status) =>
                            status.value !== ReservationStatusFilterEnum.CANCELED.value &&
                            status.value !== ReservationStatusFilterEnum.UNAVAILABLE.value,
                    )
                    .map((status) => status.value)
            },

            filterClass() {
                return {
                    'timeline-page__filter': true,
                    'timeline-page__filter--two-fields': this.locations.length > 1,
                    'timeline-page__filter--one-fields': this.locations.length <= 1,
                }
            },
        },
        methods: {
            setFilters() {
                this.filterApplied = {
                    date: this.$route.query.date ? this.$route.query.date : dayjs.utc().format('YYYY-MM-DD'),
                }
                this.updateQuery()
                if (!this.isFirstLoad) {
                    this.loadReservations()
                }
            },

            getLocations() {
                UsersAPI.getLocations().then((response) => {
                    this.locations = response
                    this.setFilters()
                })
            },

            filterChanged(payload) {
                this.filterApplied = payload
                this.updateQuery()
                this.loadReservations()
            },

            updateQuery() {
                if (this.$route.name === RoutesEnum.RESERVATIONS.TIMELINE) {
                    if (this.locations.length === 1) {
                        this.filterApplied.locationId = this.locations[0].id
                    }
                    this.$router.push({
                        query: { ...this.$route.query, date: this.filterApplied.date, locationId: this.filterApplied.locationId },
                    })
                }
            },

            loadReservations(loadPerformers = true) {
                const query = {}
                this.isLoading = true
                Store.dispatch('configuration/setIsLoading', true)
                query.dateFrom = this.filterApplied.date
                query.dateTo = this.filterApplied.date
                query.status = this.statavailabilityPerformersusOptions
                query.orderBy = ReservationSortFilterEnum.RESERVATON_TIME_ASC.value.orderBy
                query.wayDefinition = ReservationSortFilterEnum.RESERVATON_TIME_ASC.value.wayDefinition
                query.locationId = this.filterApplied.locationId
                query.loadEventItems = true
                if (loadPerformers) {
                    this.loadAvailabilityPerformers(this.filterApplied.locationId)
                    if (this.filterApplied.locationId) {
                        this.selectedPerformerId = undefined
                        delete query.performerId
                    } else {
                        this.loadSelectedPerformerId()
                    }
                }
                query.performerId = this.selectedPerformerId

                CalendarEventAPI.getReservationsReceived(query)
                    .then((res) => {
                        this.reservations = res
                        this.isFirstLoad = false
                    })
                    .finally(() => ((this.isLoading = false), Store.dispatch('configuration/setIsLoading', false)))
            },

            loadSelectedPerformerId() {
                this.selectedPerformerId = this.$route.query?.performerId
                    ? Number(this.$route.query?.performerId)
                    : this.currentUser.id
            },

            loadAvailabilityPerformers(locationId) {
                this.loadSelectedPerformerId()
                if (locationId && locationId !== this.oldLocationId) {
                    AvailabilityAPI.getAvailabilityPerformers(`locationId=${locationId}`).then((res) => {
                        this.isAviabilityPerfByLocCalled = true
                        this.oldLocationId = locationId
                        const isCurrentUserPerformer = res.find((u) => u.id === this.currentUser.id)
                        if (!isCurrentUserPerformer) {
                            this.availabilityPerformers = [...res, this.currentUser]
                        } else {
                            this.availabilityPerformers = res
                        }
                    })
                } else if ((this.isFirstLoad || this.isAviabilityPerfByLocCalled) && locationId !== this.oldLocationId) {
                    AvailabilityAPI.getAvailabilityPerformers().then((res) => {
                        const isCurrentUserPerformer = res.find((u) => u.id === this.currentUser.id)
                        if (!isCurrentUserPerformer) {
                            this.availabilityPerformers = [...res, this.currentUser]
                        } else {
                            this.availabilityPerformers = res
                        }
                        this.isAviabilityPerfByLocCalled = false
                        this.oldLocationId = undefined
                    })
                }
            },

            userSelected(user) {
                this.selectedPerformerId = user.payload
                this.loadReservations(false)
            },

            downloadPdf() {
                const query = {}
                this.isLoading = true
                Store.dispatch('configuration/setIsLoading', true)

                query.dateFrom = this.filterApplied.date
                query.dateTo = this.filterApplied.date
                query.status = [ReservationStatusFilterEnum.ACCEPTED.value, ReservationStatusFilterEnum.DONE.value]
                query.orderBy = ReservationSortFilterEnum.RESERVATON_TIME_ASC.value.orderBy
                query.wayDefinition = ReservationSortFilterEnum.RESERVATON_TIME_ASC.value.wayDefinition
                query.locationId = this.filterApplied.locationId
                query.performerId = this.selectedPerformerId
                query.loadEventItems = true

                CalendarEventAPI.getReservationsReceivedPdf(query)
                    .then((response) => {
                        const blob = new Blob([response], { type: 'application/pdf' })
                        const link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = `bookeraj-reservations-${query.dateFrom}.pdf`
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                    })
                    .finally(() => {
                        this.isLoading = false
                        Store.dispatch('configuration/setIsLoading', false)
                    })
            },
        },

        mounted() {
            this.getLocations()
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .timeline-page {
        position: relative;

        &__timeline {
            margin-top: 50px !important;
        }

        &__filter {
            &--one-filed {
                min-width: 260px;
            }
            &--two-fields {
                min-width: 520px;
            }

            @include breakpoint(smartphone-large) {
                min-width: 260px;
            }
        }
    }
</style>
